import axios from 'axios';
import Config from './../../config';
import {ProcessContentFields} from './../../helpers/CoreHelpers';

export function single(id, languageCode) {
    return (dispatch) => {
        return axios.get(Config.api.endpoint + 'api/Content/' + id + '/' + languageCode, Config.getApiConfig()).then(response => {
            if (response.data) {
                const values = ProcessContentFields(response.data.contentFields);

                values.id = response.data.id;
                values.parentContentId = response.data.parentContentId;
                values.parentWorkspaceId = response.data.parentWorkspaceId;

                dispatch({
                    type: 'BLOCK_SINGLE_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({
                    type: '@@redux-form/INITIALIZE',
                    meta: {
                        form: 'BlockForm',
                        keepDirty: undefined
                    },
                    payload: {
                        ...values,
                        languageId: languageCode
                    }
                });

                return response;
            }
        })
    }
}

export function definition(contentDefinitionKey) {
    if (contentDefinitionKey) {
        return (dispatch) => {
            return axios.get(Config.api.endpoint + 'api/Content/definition/' + contentDefinitionKey, Config.getApiConfig()).then(response => {
                if (response.data) {
                    dispatch({
                        type: 'BLOCK_DEFINITION_SUCCESS',
                        payload: {
                            data: response.data
                        }
                    });

                    return response;
                }
            })
        }
    }
}

export function structure(parentWorkspaceId, skipStore = false) {
    return (dispatch) => {
        dispatch({
            type: 'MENU_START_GET',
            payload: {
                type: 'blocks'
            }
        });

        dispatch({
            type: 'BLOCK_STRUCTURE_LOADING',
            payload: {
                skipStore: skipStore
            }
        });

        return axios.get(Config.api.endpoint + 'api/Content/structure/' + parentWorkspaceId + '/block', Config.getApiConfig({'Cache-Control': 'no-cache'})).then(response => {
            if (response.data) {
                dispatch({
                    type: 'MENU_STOP_GET',
                    payload: true
                });

                dispatch({
                    type: 'BLOCK_STRUCTURE_SUCCESS',
                    payload: {
                        data: response.data,
                        parentWorkspaceId: parentWorkspaceId,
                        skipStore: skipStore
                    }
                });

                return response;
            }
        })
    }
}

export function getWidgetList(language, skipStore = false) {
    return (dispatch) => {
        dispatch({
            type: 'WIDGETS_STRUCTURE_LOADING',
            payload: {
                skipStore: skipStore
            }
        });

        dispatch({
            type: 'MENU_START_GET',
            payload: {
                type: 'widgets'
            }
        });

        return axios.get(Config.api.endpoint + 'api/Widget/list/' + language, Config.getApiConfig({'Cache-Control': 'no-cache'})).then(response => {
            if (response.data) {
                dispatch({
                    type: 'MENU_GET_SUCCESS',
                    payload: {
                        type: 'widgets',
                        data: response.data
                    }
                });

                dispatch({
                    type: 'WIDGETS_STRUCTURE_SUCCESS',
                    payload: {
                        data: response.data,
                        skipStore: skipStore
                    }
                });

                return response;
            }
        })
    }
}

export function getTaskList() {
    return (dispatch) => {
        dispatch({
            type: 'TASK_LIST_LOADING'
        });

        return axios.get(Config.api.endpoint + 'api/Task/list', Config.getApiConfig({'Cache-Control': 'no-cache'})).then(response => {
            if (response.data) {
                dispatch({
                    type: 'TASK_LIST_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                return response;
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/core/store/actions/block.js